import type { ScenarioCollection } from '@ms/yammer-telemetry-support';

import { createNamespacedStorageValue } from './namespacedStorageValue';

const scenarioPerformance = createNamespacedStorageValue<ScenarioCollection>('ScenarioPerformance', () => ({}));

export const getScenarioPerformanceCollection = (): ScenarioCollection => scenarioPerformance.get();
export const setScenarioPerformanceCollection = (scenarioCollection: ScenarioCollection): void => {
  scenarioPerformance.set(scenarioCollection);
};
export const removeScenarioPerformanceCollection = (): void => {
  scenarioPerformance.remove();
};
